var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 20,
    viewBox: "0 0 104 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_959_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1944 0.0384763C67.9474 0.0128254 67.7003 0 67.4481 0C67.4455 0 67.4403 0 67.4377 0H61.0536V20H62.4032V1.33128H67.4507C70.8391 1.33128 73.5852 4.09901 73.5852 7.51315C73.5852 10.9273 70.8391 13.6924 67.4507 13.6924C67.4143 13.6924 67.3831 13.6924 67.3467 13.6924H65.7734V15.0237H67.0372C67.1282 15.0237 67.2089 15.0237 67.2739 15.0237C67.3727 15.0237 67.4377 15.0237 67.4481 15.0237C71.575 15.0237 74.9296 11.6532 74.9296 7.51315C74.9296 3.62447 71.9703 0.41811 68.1944 0.0410414V0.0384763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7795 7.51058C37.7795 3.62191 34.8201 0.415544 31.0443 0.0384763C30.7972 0.0128254 30.5502 0 30.2979 0C30.2953 0 30.2901 0 30.2875 0L23.9034 0V20H25.2531V1.33128H30.3005C33.6889 1.33128 36.435 4.09901 36.435 7.51315C36.435 10.9273 33.6889 13.6924 30.3005 13.6924C30.2641 13.6924 30.2329 13.6924 30.1965 13.6924H28.6232V15.0237H29.8871C29.9781 15.0237 30.0587 15.0237 30.1237 15.0237C30.2225 15.0237 30.2875 15.0237 30.2979 15.0237C30.8986 15.0237 31.4785 14.9442 32.0402 14.8108L36.0762 20.0026H37.7769L33.3821 14.3491C35.9721 13.1666 37.7821 10.5502 37.7821 7.51315L37.7795 7.51058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20H1.73711L18.5023 2.19059V20H19.7401V0H18.6245L0 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8223 1.27485H43.9894V20H45.2818V1.27485H50.5607V0H38.8223V1.27485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5302 4.93262H54.2664V19.9999H55.5302V4.93262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5302 0H54.2664V2.61126H55.5302V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8497 0H78.5573V20H79.8497V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5645 0C87.9657 0 83.4253 4.47865 83.4253 10.0013C83.4253 15.5239 87.9657 20.0026 93.5645 20.0026C99.1633 20.0026 103.704 15.5239 103.704 10.0013C103.704 4.47865 99.1659 0 93.5645 0ZM93.5645 18.6713C88.7095 18.6713 84.775 14.7903 84.775 10.0013C84.775 5.21226 88.7095 1.33128 93.5645 1.33128C98.4196 1.33128 102.354 5.21226 102.354 10.0013C102.354 14.7903 98.4196 18.6713 93.5645 18.6713Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_959_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.704,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec61ef39d8a3caae98d428e937c1fe1c.svg";
export { ForwardRef as ReactComponent };